import React, { useEffect, useState } from "react";
import { Box, Typography } from "@mui/material";

interface CountdownProps {
    targetDate: string; // ex: "2025-08-23"
}

interface TimeLeft {
    days: number;
    hours: number;
    minutes: number;
    seconds: number;
}

const Countdown: React.FC<CountdownProps> = ({ targetDate }) => {
    const parseDate = (dateString: string) => {
        const [year, month, day] = dateString.split("-").map(Number);
        return new Date(year, month - 1, day);
    };

    const calculateTimeLeft = (): TimeLeft | null => {
        const target = parseDate(targetDate);
        const now = new Date();
        const diff = target.getTime() - now.getTime();

        if (diff <= 0) return null;

        return {
            days: Math.floor(diff / (1000 * 60 * 60 * 24)),
            hours: Math.floor((diff / (1000 * 60 * 60)) % 24),
            minutes: Math.floor((diff / 1000 / 60) % 60),
            seconds: Math.floor((diff / 1000) % 60),
        };
    };

    const [timeLeft, setTimeLeft] = useState<TimeLeft | null>(calculateTimeLeft());

    useEffect(() => {
        const timer = setInterval(() => setTimeLeft(calculateTimeLeft()), 1000);
        return () => clearInterval(timer);
    }, []);

    if (!timeLeft) {
        return (
            <Typography
                textAlign="center"
                fontSize="1.6rem"
                fontWeight={600}
                color="white"
            >
                Se marient aujourd'hui !
            </Typography>
        );
    }

    const pad = (num: number) => num.toString().padStart(2, "0");

    const blocks = [
        { value: pad(timeLeft.days), label: "JOURS" },
        { value: pad(timeLeft.hours), label: "HEURES" },
        { value: pad(timeLeft.minutes), label: "MINUTES" },
        { value: pad(timeLeft.seconds), label: "SECONDES" },
    ];

    return (
        <Box
            display="flex"
            alignItems="center"
            justifyContent="center"
            gap={{ xs: 2, sm: 4 }}
            data-countdown
        >
            {blocks.map((item, index) => (
                <Box
                    key={index}
                    sx={{
                        display: "flex",
                        flexDirection: "column",
                        position: "relative",
                        textAlign: "center",
                        color:"white"
                    }}
                >
                    {/* Value */}
                    <Typography
                        fontSize="clamp(1.5rem, 2.5vw, 2.6rem)"
                        fontWeight={600}
                        letterSpacing="1px"
                    >
                        {item.value}
                    </Typography>

                    <Typography
                        fontSize="clamp(0.6rem, 1.2vw, 0.75rem)"
                        letterSpacing="2px"
                        sx={{ opacity: 0.6, mt: "4px" }}
                    >
                        {item.label}
                    </Typography>


                    {/* Separator ":" sauf après le dernier chiffre */}
                    {index < blocks.length - 1 && (
                        <Typography
                            sx={{
                                position: "absolute",
                                right: "-20px",
                                top: "5px",
                                fontSize: "clamp(1.2rem, 2vw, 2.3rem)",
                                fontWeight: 300,
                                userSelect: "none",
                                color: "white"
                            }}
                        >
                            :
                        </Typography>

                    )}
                </Box>
            ))}
        </Box>
    );
};

export default Countdown;
